import React from "react";
import { Box, Button,  Stack,  Typography } from "@mui/material";
import SimpleReactValidator from "simple-react-validator";
import InputControl from "../../../shared/components/InputControl";

export const RevertPaymentDialog = ({
  state,
  handleInputChange,
  handleFileChange,
  handleClose,
  onSubmit,
  handleFileDelete,
}) => {
  const fileRef = React.useRef();
  // Add validator instance
  const [, forceUpdate] = React.useState();
  const validator = React.useRef(
    new SimpleReactValidator({
      autoForceUpdate: { forceUpdate: forceUpdate },
    })
  );

  // Add an isDragging state
  const [isDragging, setIsDragging] = React.useState(false);

  // Modified onSubmit handler to check validation
  const handleSubmit = () => {
    if (validator.current.allValid()) {
      onSubmit();
    } else {
      validator.current.showMessages();
      forceUpdate(1);
    }
  };

  const onLogoClick = () => fileRef.current.click();

  // Update your handlers to use the state
  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleDragEnter = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);

    if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
      // Call the same handler that's used for the file input
      const fileEvent = {
        target: {
          files: e.dataTransfer.files
        }
      };
      handleFileChange(fileEvent);
    }
  };

  // Add file deletion handler
  const handleDeleteFile = (index) => {
    // Assuming handleFileDelete is provided as a prop or you have another way to update state
    const newFiles = [...state.revertPayment.files];
    newFiles.splice(index, 1);
    // Here you would update your state with the new files array
    // If you have a setter function as prop, use that
  };

  return (
    <Stack sx={{
      gap: "12px"
    }}>
      <Stack gap="4px" mt="18px">
        <Typography variant="subtitle2" color="#171717"> Reason*</Typography>
        <InputControl
          type="textarea"
          name="notes"
          placeholder="Type here..."
          rows={3}
          onChange={handleInputChange}
          value={state.revertPayment.reason}
          error={validator.current.message("Reason", state.revertPayment.reason, "required")}
          helperText={validator.current.message("Reason", state.revertPayment.reason, "required")}
        />
        {/* Add validation message */}
        {validator.current.message('reason', state.revertPayment.reason, 'required')}
      </Stack>
      <Stack gap="4px">
        <Typography variant="subtitle2" color="#171717"> Files</Typography>


        <Stack
          onClick={(e) => onLogoClick(e)}
          onDragOver={handleDragOver}
          onDragEnter={handleDragEnter}
          onDragLeave={handleDragLeave}
          onDrop={handleDrop}
          sx={{
            padding: "22px 16px",
            borderRadius: "8px",
            backgroundColor: isDragging ? "rgba(0, 0, 0, 0.05)" : "rgba(0, 0, 0, 0.03)",
            border: isDragging ? "2px dotted rgba(0, 0, 0, 0.3)" : "2px dotted rgba(0, 0, 0, 0.16)",
            gap: "6px",
            transition: "all 0.2s ease",
            cursor: "pointer",
          }}
        >
          <input
            id="contained-button-file"
            type="file"
            onChange={(e) => handleFileChange(e)}
            onClick={(e) => {
              e.target.value = null;
            }}
            style={{ display: "none" }}
            ref={fileRef}
          />
          {state.revertPayment.files.map((val, index) => {

            return (
              <Box
                key={index}
                sx={{
                  border: "1px solid #E0E0E0",
                  borderRadius: "8px",
                  padding: "8px 16px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  minHeight: "50px",
                  bgcolor: "#FFFFFF",
                }}
              >
                <Box sx={{ display: "flex", alignItems: "center", gap: "8px" }}>
                  <img
                    src={val[0]?.type?.startsWith('image/') ? "/icons/ic_image.svg" : "/icons/ic_files.svg"}
                    alt="file"
                    style={{
                      width: "24px",
                      height: "24px",
                    }}
                  />
                  <Stack>
                    <Typography
                      variant="caption"
                      sx={{
                        width: 250,
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        flexGrow: 1,
                        lineHeight: "15px",
                      }}
                    >
                      {val[0]?.name ?? ''}
                    </Typography>
                    <Typography
                      variant="caption"
                      color="text.secondary"
                      sx={{ display: "block" }}
                    >
                      {val[0]?.size < 1024 * 1024
                        ? `${(val[0]?.size / 1024).toFixed(2)} KB`
                        : `${(val[0]?.size / 1024 / 1024).toFixed(2)} MB`
                      }
                    </Typography>
                  </Stack>
                </Box>
                <img
                  style={{
                    filter: "brightness(0) saturate(100%) invert(24%) sepia(62%) saturate(2708%) hue-rotate(353deg) brightness(92%) contrast(88%)",
                    cursor: "pointer"
                  }}
                  alt="delete"
                  src="/icons/ic_delete.svg"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleFileDelete(index);
                  }}
                />
              </Box>
            )
          })}
          <Stack
            direction="row"
            gap={1}
            alignContent="center"
            alignSelf="center"
          >
            <Typography fontWeight={400} fontSize="12px" color="#808080">
              Drag & Drop Or
            </Typography>
            <Typography
              fontWeight={400}
              fontSize="12px"
              sx={{ textDecoration: "underline", cursor: "pointer" }}
            >
              Upload
            </Typography>
          </Stack>
        </Stack>
        <Stack sx={{
          flexDirection: "row",
          gap: "4px",
          alignItems: "center",
          padding: "6px 0px 10px"
        }}>
          <img style={{ height: 18 }} alt="sign" src="/icons/ic_info.svg" />
          <Typography variant="caption" lineHeight="15px" color="#666666">
            Supported Format: PDF or image file
          </Typography>
        </Stack>
      </Stack>
      <Stack flexDirection="row" gap="16px" justifyContent="end">
        <Button onClick={handleClose}>Cancel</Button>
        <Button
          type="submit"
          variant="contained"
          disabled={state.revertLoading}
          onClick={handleSubmit}
        >
          Continue
        </Button>
      </Stack>
    </Stack>
  )
};
